// 로그인 정보는 브라우저를 닫아도 유지되도록 localStorage 에 저장한다 (파일명은 기존 import 경로 유지)
const setItem = (category, fieldName, data) => {
  let sessionStorageItem = window.localStorage.getItem(category);
  let sessionStorageItemJson = JSON.parse(sessionStorageItem ? sessionStorageItem : '{}');

  sessionStorageItemJson[fieldName] = data;
  
  window.localStorage.setItem(category, JSON.stringify(sessionStorageItemJson));
}

const getItem = (category) => {
  return window.localStorage.getItem(category);
}

const getItemJsonParse = (category) => {
  return JSON.parse(getItem(category));
}

const clearItem = (category) => {
  window.localStorage.setItem(category, '{}');
}

const removeItem = (category) => {
  window.localStorage.removeItem(category);
}

const sessionStorage = {
  setItem,
  getItem,
  getItemJsonParse,
  clearItem,
  removeItem
}

export default sessionStorage;